export const lightTheme = {
  title: 'light',
  colors: {
    primary: '#00BFA5',
    background: '#F2F2F2',
    secondary100: '#2B2B45',
    secondary80: '#515065',
    secondary70: '#8E8E8E',
    secondary40: '#F2F5F9',
    secondary10: '#FFFFFF',
    red:'#DF4C4C',
    blue:'#3A89FF',
    orange: '#ff7600',
    green: '#47ffa2',
  
    overlay: 'rgba(43, 43, 69, 0.8)',
  },
 
};
export const darkTheme = {
  title: 'dark',
  colors: {
    primary: '#00BFA5',
    background: '#515065',
    secondary100: '#F2F2F2',
    secondary80: '#515065',
    secondary70: '#8E8E8E',
    secondary40: '#F2F5F9',
    secondary10: '#2B2B45',
    red:'#DF4C4C',
    blue:'#3A89FF',
    orange: '#ff7600',
    green: '#47ffa2',
  
    overlay: 'rgba(43, 43, 69, 0.8)',
  },
 
};